'use client';

import { useContext } from 'react';
import AccountDetails from 'components/gruenland/organisms/account';
import useOrderFetch from 'components/gruenland/organisms/account/sections/orders/helper-hooks/useOrderFetch';
import { AccountContext } from 'context/account';
import useHash from 'helpers/hooks/useHash';
import Redirect from 'helpers/redirect';
import { TasticProps } from 'frontastic/tastics/types';

const YggdrasilAccountDetailsTastic = ({ data }: TasticProps) => {
  const { loggedIn, account, changePassword, deleteAccount, update } = useContext(AccountContext);

  const [hash, id] = useHash();

  const { orders, loading: ordersLoading, shippingMethods } = useOrderFetch();

  if (!loggedIn) return <Redirect target="/login" />;

  return (
    <AccountDetails
      {...data}
      hash={hash}
      id={id}
      orders={orders}
      ordersLoading={ordersLoading}
      shippingMethods={shippingMethods.data ?? []}
      account={account}
      changePassword={changePassword}
      deleteAccount={deleteAccount}
      update={update}
    />
  );
};

export default YggdrasilAccountDetailsTastic;
